module.exports = __webpack_public_path__ + "img/map.3d7587dc.svg";